import * as React from 'react';

import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';

const CLEVER_APP_LINK = (
  <Link href={LinkConstants.CLEVER_APPLICATIONS} target="_blank">
    here
  </Link>
);

const SHARING_SETTINGS_LINK = (
  <Link href={LinkConstants.CONNECT_SIS} target="_blank">
    here
  </Link>
);

type SyncHoldInformation = {
  reason: {
    problem: string;
    explanation: string;
  };
  nextStep: {
    intro: string;
    bullets?: React.ReactElement[];
    footer?: string;
  };
};

export type SyncHold =
  | 'CleverDisconnectedHold'
  | 'TooManyDestructiveChangesHold'
  | 'EmergencyContactHold'
  | 'TooManyContactPointsHold';
type SyncHoldCopyMap = { [K in SyncHold]: SyncHoldInformation };

const SyncHoldCopy: SyncHoldCopyMap = {
  CleverDisconnectedHold: {
    reason: {
      problem: 'Disconnected:',
      explanation: 'We are unable to communicate with Clever.',
    },
    nextStep: {
      intro: 'Check your settings in Clever. Make sure of the following:',
      bullets: [
        <span>
          You have the Remind app installed in Clever. You can view it {CLEVER_APP_LINK}.
        </span>,
        <span>
          You are sharing the correct data with Clever. We recommending sharing district data. Learn
          about sharing settings with Remind {SHARING_SETTINGS_LINK}.
        </span>,
      ],
      footer: 'Once you’ve addressed the above, resume the sync below.',
    },
  },
  TooManyDestructiveChangesHold: {
    reason: {
      problem: 'Lots of data changes:',
      explanation: 'We have encountered a large number of destructive data changes.',
    },
    nextStep: {
      intro:
        'As a policy, we hold syncs that will have a large impact on your data. This is an opportunity to review the changes to make sure they’re expected. Once you’ve confirmed them, resume the sync below.',
    },
  },
  EmergencyContactHold: {
    reason: {
      problem: 'Data configuration:',
      explanation: 'We suspect a data configuration error in your SIS or in Clever.',
    },
    nextStep: {
      intro:
        'Emergency and secondary contacts are users that teachers don’t typically contact so we do not recommend creating accounts for them. Download the CSV of the additional contacts and review them. If you wish to sync them, resume the sync below. Otherwise, review your settings in your SIS or Clever to ensure that emergency and secondary contacts are filtered out from sync, then return here to resume the sync.',
    },
  },
  TooManyContactPointsHold: {
    reason: {
      problem: 'Data configuration:',
      explanation: 'We suspect a data configuration error in your SIS or in Clever.',
    },
    nextStep: {
      intro:
        'Accounts in your school data have six or more points of contact associated with them. This could be a mistake in your configuration. Download the CSV of these accounts and review them. If you wish to sync them, resume the sync below. Otherwise, correct them in your SIS and sync your data with Clever. Afterward, return here and resume the sync.',
    },
  },
};

export default SyncHoldCopy;
